export default __webpack_public_path__ + "static/media/kissmetrics-monochromatic.2a41b3c2.svg";